/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyInfoVo } from './CompanyInfoVo';
import {
    CompanyInfoVoFromJSON,
    CompanyInfoVoFromJSONTyped,
    CompanyInfoVoToJSON,
    CompanyInfoVoToJSONTyped,
} from './CompanyInfoVo';

/**
 * 
 * @export
 * @interface UserRegisterVo
 */
export interface UserRegisterVo {
    /**
     * 登录账号
     * @type {string}
     * @memberof UserRegisterVo
     */
    account?: string;
    /**
     * 密码
     * @type {string}
     * @memberof UserRegisterVo
     */
    password?: string;
    /**
     * 用户姓名
     * @type {string}
     * @memberof UserRegisterVo
     */
    name?: string;
    /**
     * 用户姓名 英文
     * @type {string}
     * @memberof UserRegisterVo
     */
    nameEn?: string;
    /**
     * 电话号码
     * @type {string}
     * @memberof UserRegisterVo
     */
    mobileNo?: string;
    /**
     * 电子邮箱
     * @type {string}
     * @memberof UserRegisterVo
     */
    email?: string;
    /**
     * 注册时候，填入的别人的推荐码
     * @type {string}
     * @memberof UserRegisterVo
     */
    recommendCode?: string;
    /**
     * 手机验证码（发送手机验证码接口下发，注册时与绑定手机号的验证码比对）
     * @type {string}
     * @memberof UserRegisterVo
     */
    verificationCode?: string;
    /**
     * 客户商业类型  1 企业 2 个人
     * @type {number}
     * @memberof UserRegisterVo
     */
    businessType?: number;
    /**
     * 钱包充值货币类型  目前只有韩币和人民币两种
     * @type {string}
     * @memberof UserRegisterVo
     */
    walletCurrencyCode?: string;
    /**
     * 是否含增值税 0 不含， 1 含
     * @type {number}
     * @memberof UserRegisterVo
     */
    vat?: number;
    /**
     * 
     * @type {CompanyInfoVo}
     * @memberof UserRegisterVo
     */
    chineseCompanyInfo?: CompanyInfoVo;
    /**
     * 
     * @type {CompanyInfoVo}
     * @memberof UserRegisterVo
     */
    koreanCompanyInfo?: CompanyInfoVo;
}

/**
 * Check if a given object implements the UserRegisterVo interface.
 */
export function instanceOfUserRegisterVo(value: object): value is UserRegisterVo {
    return true;
}

export function UserRegisterVoFromJSON(json: any): UserRegisterVo {
    return UserRegisterVoFromJSONTyped(json, false);
}

export function UserRegisterVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRegisterVo {
    if (json == null) {
        return json;
    }
    return {
        
        'account': json['account'] == null ? undefined : json['account'],
        'password': json['password'] == null ? undefined : json['password'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameEn': json['name_en'] == null ? undefined : json['name_en'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'email': json['email'] == null ? undefined : json['email'],
        'recommendCode': json['recommendCode'] == null ? undefined : json['recommendCode'],
        'verificationCode': json['verificationCode'] == null ? undefined : json['verificationCode'],
        'businessType': json['businessType'] == null ? undefined : json['businessType'],
        'walletCurrencyCode': json['walletCurrencyCode'] == null ? undefined : json['walletCurrencyCode'],
        'vat': json['vat'] == null ? undefined : json['vat'],
        'chineseCompanyInfo': json['chineseCompanyInfo'] == null ? undefined : CompanyInfoVoFromJSON(json['chineseCompanyInfo']),
        'koreanCompanyInfo': json['koreanCompanyInfo'] == null ? undefined : CompanyInfoVoFromJSON(json['koreanCompanyInfo']),
    };
}

export function UserRegisterVoToJSON(json: any): UserRegisterVo {
    return UserRegisterVoToJSONTyped(json, false);
}

export function UserRegisterVoToJSONTyped(value?: UserRegisterVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': value['account'],
        'password': value['password'],
        'name': value['name'],
        'name_en': value['nameEn'],
        'mobileNo': value['mobileNo'],
        'email': value['email'],
        'recommendCode': value['recommendCode'],
        'verificationCode': value['verificationCode'],
        'businessType': value['businessType'],
        'walletCurrencyCode': value['walletCurrencyCode'],
        'vat': value['vat'],
        'chineseCompanyInfo': CompanyInfoVoToJSON(value['chineseCompanyInfo']),
        'koreanCompanyInfo': CompanyInfoVoToJSON(value['koreanCompanyInfo']),
    };
}

